import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/Firebase/Login",
    name: "FirebaseLogin",
    component: () => import("@/views/Firebase/Login.vue"),
  },
  {
    path: "/Firebase/CrearCuenta",
    name: "FirebaseCrearCuenta",
    component: () => import("@/views/Firebase/CrearCuenta.vue"),
  },
  {
    path: "/Firebase/RecuperarContrasena",
    name: "FirebaseRecuperarContrasena",
    component: () => import("@/views/Firebase/RecuperarContrasena.vue"),
  },
  {
    path: "/Firebase/CompletarPerfil",
    name: "FirebaseCompletarPerfil",
    component: () => import("@/views/Firebase/CompletarPerfil.vue"),
  },
  {
    path: "/InicioSesion",
    name: "InicioSesion",
    redirect: { name: "FirebaseLogin" },
  },
  //Encuesta finalizada
  {
    path: "/encuesta/finaliza",
    name: "finalizarencuesta",
    component: () => import("@/views/UsuarioFinal/Encuestas/EncuestaFinalizadaView.vue"),
  },
  //Ver ocupación de mesas
  {
    path: "/App/ocupacion",
    name: "ocupacion",
    component: () => import("@/views/Establecimiento/VerOcupacionMesasView.vue"),
    meta: { requiresAuth: true },
  },
  //Buscar horario para reservacion
  {
    path: "/usuario/reservacion/inicio/:acceso",
    name: "inicioreservacion",
    component: () => import("@/views/UsuarioFinal/Reservaciones/BuscaHorarioView.vue"),
  },
  //Contestar encuesta
  {
    path: "/encuesta/realiza",
    name: "realizaEncuestacliente",
    component: () =>
      import("@/views/UsuarioFinal/Encuestas/RealizaEncuestaView.vue"),
  },
  //Validar la reserva del cliente
  {
    path: "/usuario/reserva/valida",
    name: "confirmaCorreoCliente",
    component: () =>
      import("@/views/UsuarioFinal/Reservaciones/ValidaReservacionClienteView.vue"),
  },
  //Aviso de reservación creada
  {
    path: "/usuario/reservacion/creada",
    name: "avisoReservacionCreada",
    component: () => import("@/views/UsuarioFinal/Reservaciones/ReservacionCreadaView.vue"),
  },
  //Crear una reservacion a un negocio (link desde la página del negocio)
  {
    path: "/usuario/reservacion/crear/:acceso",
    name: "creareservacioncliente",
    component: () => import("@/views/UsuarioFinal/Reservaciones/CrearReservacionView.vue"),
  },
  //Ver una reservación de un evento
  {
    path: "/App/reservaciones/ver",
    name: "admReservacion",
    component: () => import("@/views/Eventos/OpcionesReservacionView.vue"),
    meta: { requiresAuth: true },
  },
  //Leer QR
  {
    path: "/App/reservaciones/leerqr",
    name: "leerqr",
    component: () => import("@/views/Eventos/LeerQRView.vue"),
    meta: { requiresAuth: true },
  },
  //Crear un evento
  {
    path: "/App/eventos/crear",
    name: "crearEvento",
    component: () => import("@/views/Eventos/CrearEventoView.vue"),
    meta: { requiresAuth: true },
  },
  //Agregar un asistente al evento
  {
    path: "/App/eventos/asistentes/agrega",
    name: "agregaAsistenteEvento",
    component: () => import("@/views/Eventos/AgregaAsistenteView.vue"),
    meta: { requiresAuth: true },
  },
  //Asistentes de evento
  {
    path: "/App/eventos/asistentes",
    name: "verAsistentesEvento",
    component: () => import("@/views/Eventos/AsistentesView.vue"),
    meta: { requiresAuth: true },
  },
  //Eventos
  {
    path: "/App/eventos",
    name: "verEventos",
    component: () => import("@/views/Eventos/ListaEventosView.vue"),
    meta: { requiresAuth: true },
  },
  //Crear una reservacion
  {
    path: "/App/reservaciones/crear",
    name: "crearReservacion",
    component: () => import("@/views/Reservaciones/CrearReservacionView.vue"),
    meta: { requiresAuth: true },
  },
  //Ver las reservaciones
  {
    path: "/App/reservaciones",
    name: "reservaciones",
    component: () => import("@/views/Reservaciones/ReservacionesView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/App/Pedidos/:clavePedido",
    name: "detallePedido",
    component: () => import("@/views/Pedidos/PedidoDetalle.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/App/Pedidos",
    name: "verPedidos",
    component: () => import("@/views/Pedidos/Pedidos.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/App/Instancias",
    name: "verInstancias",
    component: () => import("@/views/Instancias/VerInstancias.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/App/CompartirInstancia",
    name: "compartirInstancia",
    component: () => import("@/views/Instancias/CompartirInstancia.vue"),
    meta: { requiresAuth: true, requiresOwner: true },
  },
  //Filas de espera
  {
    path: "/app/fila",
    name: "administraFilaEspera",
    component: () => import("@/views/FilasDeEspera/AdministraFilaEsperaView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/cm/:claveInstancia",
    name: "ConsultaMenu",
    component: () => import("@/md/cm.vue"),
  },
  {
    ///Administrar las unidades
    path: "/App/Unidades",
    name: "unidadesMedida",
    component: () => import("@/views/Unidades/Unidades.vue"),
  },
  {
    path: "/App/Secciones",
    name: "secciones",
    component: () => import("@/views/Secciones/Secciones.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/App/Secciones/:idSeccion",
    name: "seccionDetalle",
    component: () => import("@/views/Secciones/SeccionDetalle.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/App/VisualizadorSecciones",
    name: "visualizadorSecciones",
    component: () =>
      import("@/views/Secciones/VisualizadorSecciones.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/App/MapaAreas",
    name: "mapaAreas",
    component: () =>
      import("@/views/Establecimiento/EditorMapaAreasView.vue"),
    meta: { requiresAuth: true },
  },
  {
    ///Buscar producto
    path: "/App/ProductoBuscar",
    name: "buscarElemento",
    component: () => import("@/views/Producto/ProductoBuscar.vue"),
  },
  {
    ///Estadistica extendida
    path: "/App/Estadistica",
    name: "Estadistica",
    component: () => import("@/views/Estadistica/Estadistica.vue"),
  },
  {
    ///Configuración del suscriptor
    path: "/App/LogoSuscriptor",
    name: "Logo",
    component: () => import("@/views/Config/SetLogoSuscriptor.vue"),
  },
  {
    ///Configuración del suscriptor
    path: "/App/Configuracion",
    name: "Configuracion",
    component: () => import("@/views/Config/ConfiguracionSuscriptor.vue"),
  },
  {
    path: "/",
    name: "Home",
    redirect: { name: "FirebaseLogin" },
  },
  {
    path: "/App/GrupoModificador/:idGrupoModificador",
    name: "GrupoModificador",
    component: () => import("@/views/Producto/GrupoModificador.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/App/GruposModificadores",
    name: "GruposModificadores",
    component: () => import("@/views/Producto/GruposModificadores.vue"),
    meta: { requiresAuth: true },
  },
  {
    //PRODUCTO, SUBIR IMAGEN
    path: "/App/Producto/NuevaImagen/:claveProducto",
    name: "ProductoImagen",
    component: () => import("@/views/Producto/ProductoNuevaImagen.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/App/Productos",
    name: "Productos",
    component: () => import("@/views/Protected/Productos.vue"),
    meta: { requiresAuth: true },
  },
  {
    //PRODUCTO: EDITAR
    path: "/App/Producto/Editar/:claveProducto/:accion",
    name: "ProductoEditar",
    component: () => import("@/views/Producto/Producto.vue"),
    meta: { requiresAuth: true },
  },
  {
    //PRODUCTO: AGREGAR
    path: "/App/Producto/Agregar/idFamiliaSel/:idFamiliaSel/:accion",
    name: "ProductoAgregar",
    component: () => import("@/views/Producto/Producto.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/SuscriptorNuevo",
    name: "NuevoSuscriptor",
    component: () => import("@/views/NuevoSuscriptor.vue"),
  },
  {
    path: "/App/VerQR",
    name: "VerQR",
    component: () => import("@/views/Protected/VerMiQR.vue"),
    meta: { requiresAuth: true },
  },
  {
    //PRODUCTO: ELEMENTOS PAQUETE
    path: "/App/Paquete/Elementos/:claveProducto",
    name: "PaqueteElementosProducto",
    component: () => import("@/views/Producto/ElementosPaquete.vue"),
    meta: { requiresAuth: true },
  },
  {
    //PRODUCTO: IMAGENES
    path: "/App/Productos/Imgs/:claveProducto",
    name: "ImagenesProducto",
    component: () => import("@/views/Producto/ProductoImagenes.vue"),
    meta: { requiresAuth: true },
  },
  {
    //PRODUCTO: MODIFICADORES
    path: "/App/Productos/Modificadores/:claveProducto",
    name: "ModificadoresProducto",
    component: () => import("@/views/Producto/ProductoGruposModificadores.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/app/menus",
    name: "menus",
    component: () => import("@/views/Protected/Menu/Menus.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/App/MenuDetalles/:claveMenuDigital",
    name: "MenuDetalles",
    component: () => import("@/views/Protected/Menu/MenuDetalle.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/App/MenuAgregarEditar/:claveMenuDigital/:accion",
    name: "MenuAgregarEditar",
    component: () => import("@/views/Protected/Menu/MenuAgregarEditar.vue"),
    meta: { requiresAuth: true },
  },
  {
    //VENTAS ABIERTAS
    path: "/App/VentasAbiertas",
    name: "VentasAbiertas",
    component: () => import("@/views/POS/VentasAbiertas.vue"),
    meta: { requiresAuth: true },
  },
  {
    //VENTAS DETALLE VENTA
    path: "/App/VentaDetalle/:claveVenta",
    name: "VentaDetalle",
    component: () => import("@/views/POS/VentaDetalle.vue"),
    meta: { requiresAuth: true },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = "Restaurant Maestro";
  const urlProteje = to.matched.some((record) => record.meta.requiresAuth);
  var jwt = sessionStorage.jwt;

  const requierePropietario = to.matched.some(
    (record) => record.meta.requiresOwner
  );

  if (urlProteje && jwt == null) {
    next({ name: "FirebaseLogin" });
  } else if (
    requierePropietario &&
    sessionStorage.getItem("esPropietario") !== "true"
  ) {
    next({ name: "verInstancias" });
  } else {
    next();
  }
});

export default router;
